import { render, staticRenderFns } from "./updatedAt.vue?vue&type=template&id=4b924a88&"
import script from "./updatedAt.vue?vue&type=script&lang=js&"
export * from "./updatedAt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports